import { render, staticRenderFns } from "./persamaanPo.vue?vue&type=template&id=35572c49"
import script from "./persamaanPo.vue?vue&type=script&lang=js"
export * from "./persamaanPo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports